import type { OptionsMap } from '@openx/types/options';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery';

export const useKeywordsOptionsFetch = (
  keyword: string
): {
  keywordsOptions: OptionsMap;
  keywordsOptionsLoading: boolean;
} => {
  const { data, loading } = useOptionsByPathQuery({
    variables: {
      filter: {
        query: keyword,
      },
      path: 'ocs_keyword_suggestions',
    },
  });

  const keywordOptions = useMemo(() => {
    const options = data?.optionsByPath || [];

    return options.reduce((acc, item) => {
      if (item) {
        acc[item.id] = { id: item.id, name: item.name };
      }

      return acc;
    }, {});
  }, [data]);

  return {
    keywordsOptions: keywordOptions,
    keywordsOptionsLoading: loading,
  };
};
